import * as i0 from '@angular/core';
import { Injectable, Inject, Component, Input, EventEmitter, ViewEncapsulation, Output, NgModule } from '@angular/core';
import * as i1$1 from '@angular/common';
import { DOCUMENT, CommonModule } from '@angular/common';
import * as i2$1 from '@angular/router';
import { RouterModule } from '@angular/router';
import * as i4 from 'ng-zorro-antd/grid';
import { NzGridModule } from 'ng-zorro-antd/grid';
import * as i1$2 from 'ng-zorro-antd/message';
import { NzMessageModule, NzMessageServiceModule } from 'ng-zorro-antd/message';
import { NestedTreeControl } from '@angular/cdk/tree';
import * as i1 from '@angular/common/http';
import * as i4$1 from '@va/core-library/icons';
import { caretRight, caretDown, fileExcel, infoCircle, IconsModule } from '@va/core-library/icons';
import { BehaviorSubject, merge } from 'rxjs';
import { map } from 'rxjs/operators';
import { formatValue, fixedEncodeURIComponent } from '@va/core-library/common';
import * as i6 from '@angular/material/tree';
import { MatTreeModule } from '@angular/material/tree';
import * as i7 from '@angular/material/progress-bar';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import * as i3 from 'ng-zorro-antd/tooltip';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';
import * as i9 from 'ng-zorro-antd/modal';
import { NzModalModule } from 'ng-zorro-antd/modal';
import * as i2 from '@va/core-library/custom-skeleton';
import { CustomSkeletonModule } from '@va/core-library/custom-skeleton';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatTableModule } from '@angular/material/table';
import { MatButtonModule } from '@angular/material/button';
import { ButtonModule } from '@va/core-library/button';

class FormulaBarDataService {
    constructor(http, _document) {
        this.http = http;
        this._document = _document;
        this._document = document;
    }
    getFormulaData(apiEP, apiUrl, params) {
        let url = `${apiEP}${apiUrl}`;
        let paramStr = '';
        // for (const key in params) {
        //   if (Object.prototype.hasOwnProperty.call(params, key)) {
        //     const element = params[key];
        //     paramStr += `&${key}=${element}`
        //   }
        // }
        // return this.http.get(`${apiEP}${apiUrl}?${paramStr}`);
        return this.http.post(url, { ...params, isdebug: true });
    }
    getModelDetails(apiEP, params) {
        let paramStr = '';
        for (const key in params) {
            if (Object.prototype.hasOwnProperty.call(params, key)) {
                const element = params[key];
                paramStr += `&${key}=${element}`;
            }
        }
        return this.http.get(`${apiEP}/api/modeldetail?${paramStr}`);
    }
    getStatsData(apiEP, params) {
        let paramStr = '';
        for (const key in params) {
            if (Object.prototype.hasOwnProperty.call(params, key)) {
                const element = params[key];
                paramStr += `&${key}=${encodeURIComponent(element)}`;
            }
        }
        return this.http.get(`${apiEP}/api/get_stats_for_fb?${paramStr}`);
    }
    getViewModelSrc(apiEP, params) {
        let url = `/api/model?documentid=${params.documentId}
      &pg=${params.pg}&cut=${params.cut}&downloadType=${params.downloadType}&ticker=${params.ticker}&source=Filings${params.cellId !== undefined ? `&cellId=${params.cellId}` : ``}`;
        if (params.is_addin_call) {
            url = `${url}&is_addin_call=${params.is_addin_call}`;
            // if (params.ticker) {
            //   url = `${url}&ticker=${params.ticker}`;
            // }
        }
        return this.http.get(`${apiEP}${url}`);
    }
    loadFilingsHTML(url, options) {
        return this.http.get(url, options);
    }
    getPDFFilings(apiEP, params, options) {
        const url = `/api/pdf_model_filings?documentid=${params.documentId}&cellid=${params.cellId}`;
        return this.http.get(`${apiEP}${url}`, options);
    }
}
FormulaBarDataService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: FormulaBarDataService, deps: [{ token: i1.HttpClient }, { token: DOCUMENT }], target: i0.ɵɵFactoryTarget.Injectable });
FormulaBarDataService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: FormulaBarDataService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: FormulaBarDataService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: i1.HttpClient }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [DOCUMENT]
                }] }]; } });

const CONSTANTS = {
    VA_ACTUALS: "va actuals",
    CONSENSUS: "consensus",
    MODE: 'mode',
    MEAN: 'mean',
    REVISED_MODE: 'revised_mode',
    RESTATED: 'restated',
    CUSTOM: 'custom',
    YOY: 'YOY'
};

class FormulaBarUtilsService {
    constructor() {
        // counter -- append counter's value to id in order to generate a unique id before saving them in dataMap
        // sometimes more than one nodes of tree can have same id. we append _${counter} to the id to generate the unique id.
        this.counter = 0;
    }
    /**
     * It converts the raw node data into a info. that can be shown on UI.
     * e.g. It converts some raw value in the raw node by first formatting it and then converting it
     * into a sentence  which can be shown on UI and it adds a tooltip to it, to display additional information.
     * @param nodes
     * @param level
     * @returns
     */
    transformer(nodes, level) {
        const newNodes = nodes.map((node) => {
            let isFuzzy = level === 0 && node.item.isFuzzy;
            this.createDisplayVal(node.item, isFuzzy);
            this.createInfoDisplay(node.item, level);
            return {
                expandable: node.expandable,
                item: node.item,
                level: level,
                children: node.children,
                isFuzzy: isFuzzy,
                isLoading: false
            };
        });
        return newNodes;
    }
    createDisplayVal(node, isFuzzy) {
        let displayVal = node.formatted_expr || "";
        let displayValFuzzy = "";
        if (node.expression_error) {
            displayVal = `<b>${node.v ? this.formatValue(node.v) + ' =' : ''}</b> Expression Not Available`;
        }
        else if (node.isModelLine) {
            if (!node.hasChild) {
                if (node.source.toLowerCase() === 'filings') {
                    let analyst = node.analyst ? node.analyst : '', date = node.modelDate ? node.modelDate : '';
                    if (analyst || date) {
                        displayVal = `[ Filings, ${node.analyst}, ${node.modelDate}`;
                    }
                    else {
                        displayVal = "[ Filings";
                    }
                }
                else {
                    let source = node.source ? node.source : '', analyst = node.analyst ? node.analyst : '', date = node.modelDate ? node.modelDate : '', sheetName = node.modelData && node.modelData.sheet_name ? 'Sheet : ' + node.modelData.sheet_name : '', cellId = node.modelData.cellId ? 'Cell : ' + node.modelData.cellId : '';
                    let valArr = this.removeEmpty([source, analyst, date, sheetName, cellId]);
                    displayVal = valArr.length > 0 ? `[ ${valArr.join(', ')}` : ''; // no closing of square bracket, its done in html
                }
            }
        }
        else {
            displayVal = this.handleBold(node.formatted_expr, node.operator);
            displayVal = this.formatValue(displayVal);
            if (isFuzzy) {
                displayValFuzzy = displayVal;
                displayVal = `<b>&sim;${node.v} &mdash; ${node.lineItemName}</b>`;
            }
        }
        node.displayVal = displayVal;
        node.displayValFuzzy = displayValFuzzy;
    }
    /**
     * Removes empty/null values from an array
     * @param arr - array of objects
     * @returns array without any empty value
     */
    removeEmpty(arr) {
        return arr.reduce((finalValue, currentValue) => {
            if (currentValue) {
                return [...finalValue, currentValue];
            }
            else {
                return finalValue;
            }
        }, []);
    }
    createInfoDisplay(item, level) {
        let infoText = '';
        let infoTooltip = '';
        if (level === 0 || item.no_sources_entitled === true) {
            item.infoText = '';
            item.infoTooltip = '';
            item.showLink = false;
            this.baseInfo = item.baseInfo;
            return;
        }
        if (item.lineItemName) {
            infoText += item.lineItemName;
        }
        if (item.displayMagnitude) {
            infoText += ` (${item.displayMagnitude})`;
        }
        // let infoT = [
        //   item.source || '',
        //   item.period || '',
        //   item.modelDate || '',
        //   item.analyst || ''
        // ].reduce((finalValue, currentValue)=>{ // remove empty values
        //   if (currentValue) {
        //     return [...finalValue, currentValue];
        //   } else {
        //     return finalValue;
        //   }
        // }, []);
        let infoT = this.removeEmpty([
            item.source || '',
            item.period || '',
            item.modelDate || '',
            item.analyst || ''
        ]);
        infoT = infoT.length > 0 ? `[${infoT.join(', ')}]` : '';
        infoText = `${infoText} ${infoT}`;
        // infoText = `${infoText} [ ${item.source ? item.source+ ',': ''} 
        //   ${item.period ? item.period+ ',' :''} 
        //   ${item.modelDate ? item.modelDate+ ',' :''} 
        //   ${item.analyst ? item.analyst :''} 
        //  ]`
        item.showLink = item.prefix === 'SAR' && item.source.toLowerCase() !== "filings";
        if (item.showLink) {
            infoTooltip = `${infoText && infoText + ','} Load the ${item.source} model view containing
      ${item.lineItemName || ''} in a new tab`;
        }
        else {
            infoTooltip = infoText;
        }
        item.infoText = infoText;
        item.infoTooltip = infoTooltip;
    }
    handleBold(expr, operator) {
        let bold = operator && [CONSTANTS.MODE, CONSTANTS.RESTATED, CONSTANTS.REVISED_MODE, CONSTANTS.MEAN].includes(operator.trim().toLowerCase());
        let finalExpr = expr;
        if (expr.indexOf("=") != -1) {
            let valArr = expr.split("=");
            let firstVal = valArr.splice(0, 1);
            let firstValT = firstVal[0].trim();
            let isNegative = firstValT.indexOf("(") !== -1;
            // e.g. (-3,456.01)
            // replace (-3,456.01) in MODE((-3,456.01), (-3,456.01), (-3,456.01)) with <b>(-3,456.01)</b> does not work as
            // opening and closing bracket has special meaning in regular Expression. 
            // It's result is MODE((<b>(-3,456.01)</b>), (<b>(-3,456.01)</b>), (<b>(-3,456.01)</b>)) 
            // which shows two brackets in final result.
            // In order to fix it, I had to escape brackets, but any effort to replace ( with \(
            // does not work "(-3,456.01)".replace("(", "\(") results in (-3,456.01) only. So, I have to replace ( with {
            // to keep track of opening and closing brackets.
            if (isNegative) {
                firstValT = firstValT.replace("(", "{");
                firstValT = firstValT.replace(")", "}");
                valArr[0] = valArr[0].replace(/\(/g, "{");
                valArr[0] = valArr[0].replace(/\)/g, "}");
            }
            if (bold) {
                let re = new RegExp(firstValT, 'g');
                valArr[0] = valArr[0].replace(re, `<b>${firstValT}</b>`);
            }
            if (isNegative) {
                firstValT = firstValT.replace("{", "(");
                firstValT = firstValT.replace("}", ")");
                valArr[0] = valArr[0].replace(/{/g, "(");
                valArr[0] = valArr[0].replace(/}/g, ")");
            }
            finalExpr = `<b>
        <span>${firstVal}</span>
      </b>
      <span>
        = ${valArr.join("")}
      </span>`;
        }
        else {
            finalExpr = `<b> ${finalExpr}</b>`;
        }
        return finalExpr;
    }
    formatValue(expr) {
        let formattedValue = expr;
        const replaceRegex = /\(-.+?\)/g;
        const values = expr.match(replaceRegex);
        if (!values || values.length === 0) {
            return formattedValue;
        }
        values.forEach((val) => {
            // const newVal = addThousandsSeparator(Math.abs(Number(val.replace(/[^\d\.]*/g,''))), precision || 2);
            const newVal = val.replace("-", "");
            formattedValue = formattedValue.replace(val, `<span class='negative-number'>${newVal}</span>`);
        });
        return formattedValue;
    }
    setUniqueIds(data) {
        // remove _{counter} when making any api call
        if (data && data.id) {
            data.id = `${data.id}#${this.counter}`;
            this.counter++;
            if (data.children && data.children.length) {
                data.children.forEach((child) => {
                    if (child && Object.keys(child).length) {
                        this.setUniqueIds(child);
                    }
                });
            }
        }
    }
}
FormulaBarUtilsService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: FormulaBarUtilsService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
FormulaBarUtilsService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: FormulaBarUtilsService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: FormulaBarUtilsService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return []; } });

class FormulaBarDataSource {
    get data() { return this.dataChange.value; }
    set data(value) {
        this._treeControl.dataNodes = value;
        this.dataChange.next(value);
    }
    constructor(_treeControl, formulaBarService, utilsService, initialParam) {
        this._treeControl = _treeControl;
        this.formulaBarService = formulaBarService;
        this.utilsService = utilsService;
        this.initialParam = initialParam;
        // dataMap is global map of data with node id as the key, and node's children as value, so whenever we fetch data for any node, we can update
        // dataMap so that the same data can be used next time the given node expands again
        this.dataMap = new Map([]);
        this.statsData = new BehaviorSubject(null);
        this.dataChange = new BehaviorSubject([]);
    }
    createNodeData(node, level) {
        const obj = {
            node: { ...node.data, baseInfo: node.baseInfo },
            level: level,
            expandable: this.isExpandable(node.data)
        };
        return [this.getNode(obj)];
    }
    updateChildrenMap(id, childData) {
        let refinedChildData = [];
        if (id && childData) {
            childData.forEach((child) => {
                if (child && Object.keys(child).length) {
                    refinedChildData.push(child);
                }
            });
            if (refinedChildData.length) {
                this.dataMap.set(id, refinedChildData);
            }
        }
    }
    getChildren(id) {
        return this.dataMap.get(id);
    }
    isExpandable(node) {
        //isModel is true for SAR line i.e. parent line to actual model line
        // we identify actual model line with isModelLine flag, which add to the node's data in UI only
        if (node.isModel) {
            return true;
        }
        return node.hasChild;
    }
    getNode(obj) {
        const newObj = {
            item: obj.node,
            expandable: obj.expandable,
            level: obj.level,
            children: obj.children,
            isLoading: false
        };
        return newObj;
    }
    connect(collectionViewer) {
        this._treeControl.expansionModel.changed.subscribe(change => {
            if (change.added ||
                change.removed) {
                this.handleTreeControl(change);
            }
        });
        return merge(collectionViewer.viewChange, this.dataChange).pipe(map(() => this.data));
    }
    /** Handle expand/collapse behaviors */
    handleTreeControl(change) {
        if (change.added) {
            change.added.forEach(node => this.toggleNode(node, true));
        }
        if (change.removed) {
            change.removed.slice().reverse().forEach(node => this.toggleNode(node, false));
        }
    }
    // get scroll position inside a div
    getSetScrollPosition(position) {
        let nodes = document.getElementsByClassName("first-expanded-node");
        if (nodes.length) {
            if (position) {
                nodes[0].scrollTop = position;
                return;
            }
            else {
                return nodes[0].scrollTop;
            }
        }
    }
    updateUi() {
        let position = this.getSetScrollPosition();
        let tempData = [...this.data];
        this.dataChange.next([]);
        this.dataChange.next(tempData);
        this.getSetScrollPosition(position);
    }
    /**
     * Toggle the node, remove from display list
     * whenever toggle button is clicked, it either adds node on UI or removes it
     *
     */
    toggleNode(node, expand) {
        let children = this.getChildren(node.item.id);
        // If no children, or cannot find the node, no op
        if (!this.isExpandable(node.item)) {
            return;
        }
        if (expand) {
            node.isLoading = true;
            // if children is already available in the raw data i.e. dataMap, i.e. it was previously loaded, then just convert it into
            // display info and trigger the dataChange, so that it is updated on UI.
            if (children && !node.item.isModel) {
                const nodes = this.utilsService.transformer(children.map(name => {
                    const obj = {
                        node: name,
                        level: node.level + 1,
                        expandable: this.isExpandable(name),
                        isLoading: false
                    };
                    let nodeT = this.getNode(obj);
                    nodeT.item.baseInfo = {
                        ...this.initialParam
                    };
                    return nodeT;
                }), node.level + 1);
                node.children = nodes;
                node.isLoading = false;
                this.updateUi();
            }
            else if (node.item.hasChild && !node.item.isModel) {
                node.isLoading = true;
                //make second dp call 
                let dpId = node.item.id && node.item.id.split('#')[0];
                let param = {
                    source: node.item.source,
                    dp: dpId,
                    cut: node.item.prefix,
                    ticker: this.initialParam.dpCallObj.ticker,
                    period: node.item.fiscalPeriod,
                    shouldLog: true,
                };
                if (this.initialParam.dpCallObj.historicalRevision) {
                    param.historicalRevision = this.initialParam.dpCallObj.historicalRevision;
                }
                // if(node.item.prefix && node.item.prefix.toLowerCase() === CONSTANTS.CUSTOM.toLowerCase()) {
                //   (param as any).incl_sources = this.initialParam.dpCallObj.incl_sources;
                //   (param as any).excl_sources = this.initialParam.dpCallObj.excl_sources;
                //   // API is returning CUSTOM(i.e. uppercase) in node, but custom(i.e. lowercase )is needed in input
                //   // need to get this fixed from Core BE side
                //   (param as any).source = param.source.toLowerCase();
                // }
                // if(node.item.prefix && node.item.prefix.toLowerCase() === CONSTANTS.YOY.toLowerCase()) {
                //   (param as any).growthType = this.initialParam.dpCallObj.growthType;
                // }
                // If code flow reaches here means that first get_fb call was made with depth level 1
                // For some cases like custom consensus or YOY, we need more info than source,cut, period, dpId.
                // So instead of adding that info for each case separately we can repeat the first call with depth 3 or 4.
                // dpeth 4 is needed for cases where these three custom consensus+YOY+currency combinations are applied
                // In such case even at third level the rid is still custom rid
                if (node.level === 0) {
                    param = this.initialParam.dpCallObj;
                    param.requested_depth_level = 3;
                    if (dpId.toLowerCase().indexOf("yoy_custom") !== -1) {
                        param.requested_depth_level = 4;
                    }
                }
                this.formulaBarService.getFormulaData(this.initialParam.apiEP, this.initialParam.apiUrl, param).subscribe((data) => {
                    if (data.status === "error") {
                        let nodes = [{
                                children: null,
                                expandable: false,
                                isFuzzy: false,
                                isLoading: false,
                                level: null,
                                isError: true,
                                item: {
                                    hasChild: false,
                                    isModel: false,
                                    formatted_expr: "",
                                    id: "",
                                    isModelLine: false,
                                    displayVal: data.message || "Data not available"
                                }
                            }];
                        node.children = nodes;
                        node.isLoading = false;
                        this.updateUi();
                    }
                    else {
                        data.baseInfo = {
                            ...this.initialParam
                        };
                        this.utilsService.setUniqueIds(data.data);
                        this.updateChildren(data.data);
                        this.updateChildrenMap(node.item.id, data.data.children);
                        // const newNode = this.utilsService.transformer( this.createNodeData(data,  node.level + 1), node.level + 1)
                        // node.children = newNode;
                        children = this.getChildren(node.item.id);
                        if (children) {
                            const nodes = this.utilsService.transformer(children.map(name => {
                                const obj = {
                                    node: name,
                                    level: node.level + 1,
                                    expandable: this.isExpandable(name),
                                    isLoading: false
                                };
                                return this.getNode(obj);
                            }), node.level + 1);
                            node.children = nodes;
                        }
                        node.isLoading = false;
                        this.updateUi();
                    }
                });
            }
            else {
                children = this.getChildren(node.item.id + '-model');
                if (children) {
                    const nodes = this.utilsService.transformer(children.map(name => {
                        const obj = {
                            node: name,
                            level: node.level + 1,
                            expandable: this.isExpandable(name),
                            isLoading: false
                        };
                        return this.getNode(obj);
                    }), node.level + 1);
                    node.children = nodes;
                    let tempData = this.data;
                    node.isLoading = false;
                    this.updateUi();
                }
                else {
                    node.isLoading = true;
                    let dpId = node.item.id.split("#")[0]; // remove #number from dp id which was appended to it to make it unique.
                    dpId = dpId.split("_")[1]; // remove SAR_ from dp id
                    //make model details call
                    const params = {
                        dp: dpId,
                        cut: node.item.prefix,
                        source: node.item.source,
                        company: this.initialParam.dpCallObj.ticker,
                        documentid: node.item.modelData.documentId
                    };
                    this.formulaBarService.getModelDetails(this.initialParam.apiEP, params).subscribe((data) => {
                        if (data.documentId) {
                            const nodeData = {
                                data: {
                                    id: node.item.id + '-model',
                                    formatted_expr: '',
                                    value: '',
                                    hasChild: false,
                                    source: node.item.source,
                                    analyst: node.item.analyst || '',
                                    lineItemName: node.item.lineItemName,
                                    modelDate: data.docDate,
                                    cut: node.item.prefix,
                                    children: [],
                                    isModelLine: true,
                                    modelData: { ...node.item.modelData, ...data }
                                },
                                baseInfo: {
                                    ...this.initialParam
                                }
                            };
                            this.updateChildrenMap(nodeData.data.id, [nodeData.data]);
                            const newNode = this.utilsService.transformer(this.createNodeData(nodeData, node.level + 1), node.level + 1);
                            node.children = newNode;
                            node.isLoading = false;
                            this.updateUi();
                        }
                        else {
                            node.isLoading = false;
                        }
                    });
                }
            }
            if (this.initialParam.dpCallObj.cut !== "SAR"
                && !this.statsData.value
                && node.level === 0) {
                this.statsData.next({ isLoading: true });
                this.getStats(this.initialParam.dpCallObj);
            }
            else if (this.initialParam.dpCallObj.cut === "SAR") {
                this.statsData.next({ isLoading: false });
            }
        }
        else {
            node.children = null;
            this.updateUi();
        }
    }
    updateChildren(data) {
        if (data && data.children && data.children.length) {
            this.updateChildrenMap(data.id, data.children);
            data.children.map((dataT) => {
                this.updateChildren(dataT);
            });
        }
    }
    getStats(params) {
        this.formulaBarService.getStatsData(this.initialParam.apiEP, params).subscribe((response) => {
            this.statsData.next(response.data);
        });
    }
}

class FormulaBarStatsComponent {
    constructor() {
        this.apiEP = "";
    }
    getAbsoluteValue(value) {
        return Math.abs(value);
    }
}
FormulaBarStatsComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: FormulaBarStatsComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
FormulaBarStatsComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: FormulaBarStatsComponent, selector: "va-formula-bar-stats", inputs: { apiEP: "apiEP", dpCallObj: "dpCallObj", statsData: "statsData" }, ngImport: i0, template: "<div *ngIf=\"statsData && statsData.isLoading\">\n  <va-custom-skeleton\n    [customSkeletonConfig]=\"{\n      skeletonType: 'list',\n      config: {\n        list: {\n          noOfListItems: 2\n        }\n      }\n    }\"\n  ></va-custom-skeleton>\n</div>\n<div class=\"stats-container\" *ngIf=\"statsData && !statsData.isLoading\">\n  <ng-container >\n    <div class=\"stats-header\">\n      <span>\n        {{statsData.lineItemName}}\n        <span *ngIf=\"statsData.fuzzyLineName\" class=\"fuzzy-info\">&mdash;{{statsData.fuzzyLineName}}</span>\n      </span>\n      <span *ngIf=\"statsData.displayMagnitude\">\n        ({{statsData.displayMagnitude}})\n      </span>\n      <span>&nbsp;(</span>\n      <span *ngIf=\"statsData.source\">{{statsData.source}}</span>\n      <span *ngIf=\"statsData.period\">, {{statsData.period}}</span>\n      <span *ngIf=\"statsData.historicalRevision\">, {{statsData.historicalRevision}}</span>\n      <span *ngIf=\"statsData.growthType\">, {{statsData.growthType}}</span>\n      <span *ngIf=\"statsData.calculationMethod\">, {{statsData.calculationMethod}} </span>\n      <span>)</span>\n    </div>\n    <div class=\"stats-details\">\n      <div class=\"node\" *ngFor=\"let item of statsData.details\">\n        <span class=\"stats-header\">\n          {{item.title}} =\n        </span>\n        <span\n          *ngIf=\"item.rawValue<0\"\n          class=\"stats-val negative-number\"\n        >\n          ({{item.value}})\n        </span>\n        <span\n          *ngIf=\"item.rawValue>=0\"\n          class=\"stats-val\"\n        >\n          {{item.value}}\n        </span>\n        <span\n          *ngIf=\"item.sName\"\n          class=\"stats-val\"\n        >\n          [{{item.sName}}]\n        </span>\n      </div>\n    </div>\n  </ng-container>\n</div>", styles: [":host{width:100%}:host .stats-container{height:auto;padding:10px 15px;position:relative;background-color:#e0e1e1;display:inline-block;width:100%;color:#000;font-size:13px;line-height:1.5}:host .stats-container .stats-details{font-size:13px;display:flex;flex-wrap:wrap;margin-top:10px}:host .stats-container .stats-details .node{width:33%;display:block}:host .stats-container .stats-header{font-weight:700}:host .stats-container .fuzzy-info{color:#e6a935}:host .stats-container .stats-val{font-weight:400}:host .stats-container .negative-number{color:#e61f00}\n"], dependencies: [{ kind: "directive", type: i1$1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i2.CustomSkeletonComponent, selector: "va-custom-skeleton", inputs: ["customSkeletonConfig"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: FormulaBarStatsComponent, decorators: [{
            type: Component,
            args: [{ selector: 'va-formula-bar-stats', template: "<div *ngIf=\"statsData && statsData.isLoading\">\n  <va-custom-skeleton\n    [customSkeletonConfig]=\"{\n      skeletonType: 'list',\n      config: {\n        list: {\n          noOfListItems: 2\n        }\n      }\n    }\"\n  ></va-custom-skeleton>\n</div>\n<div class=\"stats-container\" *ngIf=\"statsData && !statsData.isLoading\">\n  <ng-container >\n    <div class=\"stats-header\">\n      <span>\n        {{statsData.lineItemName}}\n        <span *ngIf=\"statsData.fuzzyLineName\" class=\"fuzzy-info\">&mdash;{{statsData.fuzzyLineName}}</span>\n      </span>\n      <span *ngIf=\"statsData.displayMagnitude\">\n        ({{statsData.displayMagnitude}})\n      </span>\n      <span>&nbsp;(</span>\n      <span *ngIf=\"statsData.source\">{{statsData.source}}</span>\n      <span *ngIf=\"statsData.period\">, {{statsData.period}}</span>\n      <span *ngIf=\"statsData.historicalRevision\">, {{statsData.historicalRevision}}</span>\n      <span *ngIf=\"statsData.growthType\">, {{statsData.growthType}}</span>\n      <span *ngIf=\"statsData.calculationMethod\">, {{statsData.calculationMethod}} </span>\n      <span>)</span>\n    </div>\n    <div class=\"stats-details\">\n      <div class=\"node\" *ngFor=\"let item of statsData.details\">\n        <span class=\"stats-header\">\n          {{item.title}} =\n        </span>\n        <span\n          *ngIf=\"item.rawValue<0\"\n          class=\"stats-val negative-number\"\n        >\n          ({{item.value}})\n        </span>\n        <span\n          *ngIf=\"item.rawValue>=0\"\n          class=\"stats-val\"\n        >\n          {{item.value}}\n        </span>\n        <span\n          *ngIf=\"item.sName\"\n          class=\"stats-val\"\n        >\n          [{{item.sName}}]\n        </span>\n      </div>\n    </div>\n  </ng-container>\n</div>", styles: [":host{width:100%}:host .stats-container{height:auto;padding:10px 15px;position:relative;background-color:#e0e1e1;display:inline-block;width:100%;color:#000;font-size:13px;line-height:1.5}:host .stats-container .stats-details{font-size:13px;display:flex;flex-wrap:wrap;margin-top:10px}:host .stats-container .stats-details .node{width:33%;display:block}:host .stats-container .stats-header{font-weight:700}:host .stats-container .fuzzy-info{color:#e6a935}:host .stats-container .stats-val{font-weight:400}:host .stats-container .negative-number{color:#e61f00}\n"] }]
        }], propDecorators: { apiEP: [{
                type: Input
            }], dpCallObj: [{
                type: Input
            }], statsData: [{
                type: Input
            }] } });

class DirectMappingsComponent {
}
DirectMappingsComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: DirectMappingsComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
DirectMappingsComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: DirectMappingsComponent, selector: "va-direct-mappings", inputs: { dpCallObj: "dpCallObj", disableLinks: "disableLinks", directMappings: "directMappings" }, ngImport: i0, template: "<div class=\"va-direct-mappings\">\n  <div class=\"mappings-section\">\n    <div>\n      <div nz-row class=\"heading\">\n        Direct Mappings\n      </div>\n      <div nz-row class=\"value-and-links\">\n        <div nz-col nzSpan=\"12\" class=\"data-point-wrapper\">\n          <span class=\"data-point\">\n            {{directMappings.info.value}}\n          </span>\n        </div>\n        <div class=\"links-section\">\n          <div *ngFor=\"let link of directMappings.linkMapping.CAP\" class=\"dm-link\">\n            <ng-container\n              [ngTemplateOutlet]=\"linkTemplate\"\n              [ngTemplateOutletContext]=\"{\n                link: link,\n                directMappingsInfo: directMappings.info\n              }\"\n            >\n            </ng-container>\n          </div>\n        </div>\n      </div>\n    </div>\n    <div\n      *ngIf=\"\n        directMappings.linkMapping &&\n        directMappings.linkMapping.COM &&\n        directMappings.linkMapping.COM.length > 0\n      \"\n      class=\"other-links\"\n    >\n      <div nz-row class=\"heading\">\n        Also Used in These Calculations\n      </div>\n      <div nz-row class=\"value-and-links\">\n        <div class=\"links-section\">\n          <div *ngFor=\"let link of directMappings.linkMapping.COM\">\n            <ng-container\n              [ngTemplateOutlet]=\"linkTemplate\"\n              [ngTemplateOutletContext]=\"{\n                link: link,\n                directMappingsInfo: directMappings.info\n              }\"\n            >\n            </ng-container>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n\n  <div\n    *ngIf=\"dpCallObj.cut === 'SAR'\"\n    class=\"sar-header\"\n  >\n    <b>\n      <span>{{ directMappings.info.name }}</span>\n      <span>&nbsp;(</span>\n      <span *ngIf=\"directMappings.info.source\">{{directMappings.info.source}}</span>\n      <span *ngIf=\"directMappings.info.period\">, {{directMappings.info.period}}\n        <span *ngIf=\"directMappings.info.forecast\">E</span>\n      </span>\n      <span *ngIf=\"directMappings.info.growthType\">, {{directMappings.info.growthType}}</span>\n      <span>)</span>\n    </b>\n  </div>\n</div>\n<ng-template #linkTemplate let-link=\"link\" let-directMappingsInfo=\"directMappingsInfo\" >\n  <!-- formulabarData.fiscalperiod -- TODO: need to check, where fiscal will come from .. for queryParams -->\n  <a\n    *ngIf=\"!disableLinks\"\n    routerLink=\"/mex/{{ directMappingsInfo.ticker }}/NMV/{{\n      link.tabSName\n    }}\"\n    [queryParams]=\"{\n      expand_consensus: true,\n      dpid: link.dpid,\n      period: directMappingsInfo.fiscalPeriod\n    }\"\n    queryParamsHandling=\"merge\"\n    target=\"_blank\"\n    nz-tooltip\n    nzTooltipTitle=\"Load the {{\n      directMappingsInfo.source\n    }} model view containing {{ link.name }} in a new tab\"\n    nzTooltipPlacement=\"right\"\n    nzTooltipMouseEnterDelay=\"10\"\n    [nzTooltipOverlayStyle]=\"{\n      fontSize: '11px',\n      padding: '0px',\n      background: '#999'\n    }\"\n  >\n    <span\n      >[{{ link.tabName }}] {{ link.name }} ({{\n        directMappingsInfo.source\n      }}, {{ directMappingsInfo.period }})\n    </span>\n  </a>\n</ng-template>", styles: [".va-direct-mappings{border-top:1px solid #bdc1c5}.va-direct-mappings .mappings-section{padding:10px 5px 5px 15px;margin-top:5px}.va-direct-mappings .mappings-section .heading{font-size:12px;font-weight:700}.va-direct-mappings .mappings-section .value-and-links{padding-top:5px;padding-bottom:5px}.va-direct-mappings .mappings-section .data-point-wrapper{height:22px}.va-direct-mappings .mappings-section .data-point{border:2px solid #0c0;padding:1px 3px}.va-direct-mappings .mappings-section .links-section{font-size:11px;line-height:16px}.va-direct-mappings .mappings-section .links-section a{color:#1874ae}.va-direct-mappings .mappings-section .other-links{border-top:1px solid #bdc1c5;padding-top:10px}.va-direct-mappings .sar-header{background-color:#e0e1e1;width:100%;padding:10px;font-size:13px;line-height:1.5;color:#000}\n"], dependencies: [{ kind: "directive", type: i1$1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1$1.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "directive", type: i2$1.RouterLink, selector: "[routerLink]", inputs: ["target", "queryParams", "fragment", "queryParamsHandling", "state", "relativeTo", "preserveFragment", "skipLocationChange", "replaceUrl", "routerLink"] }, { kind: "directive", type: i3.NzTooltipDirective, selector: "[nz-tooltip]", inputs: ["nzTooltipTitle", "nzTooltipTitleContext", "nz-tooltip", "nzTooltipTrigger", "nzTooltipPlacement", "nzTooltipOrigin", "nzTooltipVisible", "nzTooltipMouseEnterDelay", "nzTooltipMouseLeaveDelay", "nzTooltipOverlayClassName", "nzTooltipOverlayStyle", "nzTooltipArrowPointAtCenter", "nzTooltipColor"], outputs: ["nzTooltipVisibleChange"], exportAs: ["nzTooltip"] }, { kind: "directive", type: i4.NzColDirective, selector: "[nz-col],nz-col,nz-form-control,nz-form-label", inputs: ["nzFlex", "nzSpan", "nzOrder", "nzOffset", "nzPush", "nzPull", "nzXs", "nzSm", "nzMd", "nzLg", "nzXl", "nzXXl"], exportAs: ["nzCol"] }, { kind: "directive", type: i4.NzRowDirective, selector: "[nz-row],nz-row,nz-form-item", inputs: ["nzAlign", "nzJustify", "nzGutter"], exportAs: ["nzRow"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: DirectMappingsComponent, decorators: [{
            type: Component,
            args: [{ selector: 'va-direct-mappings', template: "<div class=\"va-direct-mappings\">\n  <div class=\"mappings-section\">\n    <div>\n      <div nz-row class=\"heading\">\n        Direct Mappings\n      </div>\n      <div nz-row class=\"value-and-links\">\n        <div nz-col nzSpan=\"12\" class=\"data-point-wrapper\">\n          <span class=\"data-point\">\n            {{directMappings.info.value}}\n          </span>\n        </div>\n        <div class=\"links-section\">\n          <div *ngFor=\"let link of directMappings.linkMapping.CAP\" class=\"dm-link\">\n            <ng-container\n              [ngTemplateOutlet]=\"linkTemplate\"\n              [ngTemplateOutletContext]=\"{\n                link: link,\n                directMappingsInfo: directMappings.info\n              }\"\n            >\n            </ng-container>\n          </div>\n        </div>\n      </div>\n    </div>\n    <div\n      *ngIf=\"\n        directMappings.linkMapping &&\n        directMappings.linkMapping.COM &&\n        directMappings.linkMapping.COM.length > 0\n      \"\n      class=\"other-links\"\n    >\n      <div nz-row class=\"heading\">\n        Also Used in These Calculations\n      </div>\n      <div nz-row class=\"value-and-links\">\n        <div class=\"links-section\">\n          <div *ngFor=\"let link of directMappings.linkMapping.COM\">\n            <ng-container\n              [ngTemplateOutlet]=\"linkTemplate\"\n              [ngTemplateOutletContext]=\"{\n                link: link,\n                directMappingsInfo: directMappings.info\n              }\"\n            >\n            </ng-container>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n\n  <div\n    *ngIf=\"dpCallObj.cut === 'SAR'\"\n    class=\"sar-header\"\n  >\n    <b>\n      <span>{{ directMappings.info.name }}</span>\n      <span>&nbsp;(</span>\n      <span *ngIf=\"directMappings.info.source\">{{directMappings.info.source}}</span>\n      <span *ngIf=\"directMappings.info.period\">, {{directMappings.info.period}}\n        <span *ngIf=\"directMappings.info.forecast\">E</span>\n      </span>\n      <span *ngIf=\"directMappings.info.growthType\">, {{directMappings.info.growthType}}</span>\n      <span>)</span>\n    </b>\n  </div>\n</div>\n<ng-template #linkTemplate let-link=\"link\" let-directMappingsInfo=\"directMappingsInfo\" >\n  <!-- formulabarData.fiscalperiod -- TODO: need to check, where fiscal will come from .. for queryParams -->\n  <a\n    *ngIf=\"!disableLinks\"\n    routerLink=\"/mex/{{ directMappingsInfo.ticker }}/NMV/{{\n      link.tabSName\n    }}\"\n    [queryParams]=\"{\n      expand_consensus: true,\n      dpid: link.dpid,\n      period: directMappingsInfo.fiscalPeriod\n    }\"\n    queryParamsHandling=\"merge\"\n    target=\"_blank\"\n    nz-tooltip\n    nzTooltipTitle=\"Load the {{\n      directMappingsInfo.source\n    }} model view containing {{ link.name }} in a new tab\"\n    nzTooltipPlacement=\"right\"\n    nzTooltipMouseEnterDelay=\"10\"\n    [nzTooltipOverlayStyle]=\"{\n      fontSize: '11px',\n      padding: '0px',\n      background: '#999'\n    }\"\n  >\n    <span\n      >[{{ link.tabName }}] {{ link.name }} ({{\n        directMappingsInfo.source\n      }}, {{ directMappingsInfo.period }})\n    </span>\n  </a>\n</ng-template>", styles: [".va-direct-mappings{border-top:1px solid #bdc1c5}.va-direct-mappings .mappings-section{padding:10px 5px 5px 15px;margin-top:5px}.va-direct-mappings .mappings-section .heading{font-size:12px;font-weight:700}.va-direct-mappings .mappings-section .value-and-links{padding-top:5px;padding-bottom:5px}.va-direct-mappings .mappings-section .data-point-wrapper{height:22px}.va-direct-mappings .mappings-section .data-point{border:2px solid #0c0;padding:1px 3px}.va-direct-mappings .mappings-section .links-section{font-size:11px;line-height:16px}.va-direct-mappings .mappings-section .links-section a{color:#1874ae}.va-direct-mappings .mappings-section .other-links{border-top:1px solid #bdc1c5;padding-top:10px}.va-direct-mappings .sar-header{background-color:#e0e1e1;width:100%;padding:10px;font-size:13px;line-height:1.5;color:#000}\n"] }]
        }], propDecorators: { dpCallObj: [{
                type: Input
            }], disableLinks: [{
                type: Input
            }], directMappings: [{
                type: Input
            }] } });

class FormulaBarComponent {
    constructor(message, dataService, utilsService, _document, iconRegistry) {
        this.message = message;
        this.dataService = dataService;
        this.utilsService = utilsService;
        this._document = _document;
        this.iconRegistry = iconRegistry;
        this.apiEP = "";
        this.apiUrl = "/api/get_fb";
        // We don't show links in excel addin. This flag can be used to disable links
        this.disableLinks = false;
        this.expandOnInit = false;
        this.onNodeToggle = new EventEmitter();
        this.onDownloadModel = new EventEmitter();
        this.isFbLoading = false;
        this.isError = false;
        this.errorMessage = "";
        this.showFormulaBar = false;
        this.directMappings = null;
        this.domIdToScroll = "";
        this.isViewModalVisible = false;
        this.filingsError = false;
        this.treeControl = null;
        this.hasChildTT = (_, node) => node.expandable;
        this.showStats = (node) => {
            return node.level === 1;
        };
        this._document = document;
        this.iconRegistry.registerIcons([caretRight, caretDown, fileExcel, infoCircle]);
    }
    ngOnChanges(changes) {
        if (changes.expandOnInit && changes.expandOnInit.currentValue !== changes.expandOnInit.previousValue) {
            if (this.expandOnInit) {
                this.expandNode();
            }
        }
        if ((changes.dpCallObj && changes.dpCallObj.currentValue !== changes.dpCallObj.previousValue) ||
            (changes.apiEP && changes.apiEP.currentValue !== changes.apiEP.previousValue) ||
            (changes.apiUrl && changes.apiUrl.currentValue !== changes.apiUrl.previousValue)) {
            this.treeControl = new NestedTreeControl(node => node.children);
            // reset counter for unique id generation
            this.utilsService.counter = 0;
            this.showFormulaBar = true;
            if (this.dpCallObj.cut === "SAR") {
                this.dpCallObj.get_nmv_link = true;
            }
            const initialParam = {
                apiEP: this.apiEP,
                apiUrl: this.apiUrl,
                dpCallObj: this.dpCallObj
            };
            this.isFbLoading = true;
            this.dataSource = new FormulaBarDataSource(this.treeControl, this.dataService, this.utilsService, initialParam);
            if (this.fbSubscription) {
                this.fbSubscription.unsubscribe();
            }
            this.fbSubscription = this.dataService.getFormulaData(this.apiEP, this.apiUrl, this.dpCallObj).subscribe((data) => {
                if (data.status === "error") {
                    this.setError(data);
                }
                else if (data.data) {
                    this.isError = false;
                    data.baseInfo = {
                        ...this.dpCallObj
                    };
                    // Here we made api call for base node, and base node should always have at least one children
                    // e.g. for REF_ dp ids we show value at base level and we show full details at child level and it has only one child
                    // In such cases, we have to add base node again at child level.
                    if (!data.data.hasChild) {
                        data.data.children = [{
                                ...data.data
                            }];
                        data.data.hasChild = true;
                    }
                    this.utilsService.setUniqueIds(data.data);
                    const node = this.dataSource.createNodeData(data, 0);
                    // update dataMap with node and its children
                    this.dataSource.updateChildren(data.data);
                    // if node has children then update them as well in dataMap
                    // data.data.children.forEach((child) => child && this.dataSource.updateChildrenMap(child.id ,child))
                    this.dataSource.data = this.utilsService.transformer(node, 0);
                    this.isFbLoading = false;
                    if (this.expandOnInit) {
                        this.expandNode();
                    }
                    this.dataSource.statsData.subscribe((st) => {
                        if (st && st.isLoading) {
                            this.statsT = { isLoading: true };
                        }
                        else {
                            if (st && st.stats) {
                                // let otherData = {
                                //   period: data.data.period,
                                //   lineItemName: data.data.lineItemName,
                                //   source: data.data.source,
                                //   growthType: data.data.growthType
                                // }
                                this.statsT = this.modifyStatsObject(st, data.data, this.dpCallObj);
                            }
                            else {
                                this.statsT = this.createStatsHeader(data.data, this.dpCallObj);
                            }
                        }
                    });
                    if (data.data.nmvlinks) {
                        this.setMappingLinks(data.data, this.dpCallObj);
                    }
                    else {
                        this.directMappings = null;
                    }
                }
                else {
                    this.setError(data);
                }
            });
        }
    }
    setError(data) {
        this.isError = true;
        this.isFbLoading = false;
        this.errorMessage = data.message || "Data not available";
    }
    // getDirectMappings(data) {
    //   let links = [
    //     {
    //       tabSName: "IS",
    //       fiscalperiod: "FY-2023",
    //       name: "revenue",
    //       tabName: "Income Statement",
    //     },
    //     {
    //       tabSName: "BS",
    //       fiscalperiod: "FY-2022",
    //       name: "Sales",
    //       tabName: "Business Statement",
    //     }
    //   ];
    // }
    setMappingLinks(data, dpCallObj) {
        const linksObjs = data.nmvlinks;
        // const capComMapping = Object.values(linksObjs[0]);
        const linkMapping = { CAP: [], COM: [] };
        const capIds = linksObjs.cap_dpids;
        const linksObj = linksObjs.dap_param_details;
        for (const id in linksObj) {
            const tabs = linksObj[id].tabs;
            const name = linksObj[id].name;
            const dpId = `${linksObj[id].rid}|${data.revision_date}`;
            for (let i = 0; i < tabs.length; i++) {
                if (capIds.includes(Number(id))) {
                    linkMapping["CAP"].push({
                        name: name,
                        tabSName: tabs[i][0],
                        tabName: tabs[i][1],
                        dpid: dpId,
                    });
                }
                else {
                    linkMapping["COM"].push({
                        name: name,
                        tabSName: tabs[i][0],
                        tabName: tabs[i][1],
                        dpid: dpId,
                    });
                }
            }
        }
        this.directMappings = {};
        this.directMappings["linkMapping"] = linkMapping;
        this.directMappings.info = {
            ticker: dpCallObj.ticker,
            value: data.v,
            name: data.lineItemName,
            source: data.source,
            period: data.period,
            fiscalPeriod: data.fiscalPeriod,
            // forecast:
            growthType: data.growthtype
        };
    }
    modifyStatsObject(data, otherData, dpCallObj) {
        if (data && data.stats) {
            const finalStats = this.createStatsHeader(otherData, dpCallObj);
            if (otherData.source && otherData.source.toLowerCase() === CONSTANTS.VA_ACTUALS
                && data.stats && Object.keys(data.stats).length) {
                if (otherData.operator && (otherData.operator.trim().toLowerCase() === CONSTANTS.MODE ||
                    otherData.operator.trim().toLowerCase() === CONSTANTS.REVISED_MODE ||
                    otherData.operator.trim().toLowerCase() === CONSTANTS.RESTATED)) {
                    if (data.stats.broker_count) {
                        finalStats.details.push(this.createStatsDetails(data.stats.broker_count, "Number of brokers in mode", false));
                    }
                    if (data.stats.consensus_count) {
                        finalStats.details.push({
                            title: "Total brokers",
                            value: formatValue(data.stats.consensus_count, 2),
                            rawValue: data.stats.consensus_count
                        });
                    }
                    if (data.stats.filing_value) {
                        finalStats.details.push({
                            title: "Company reported actual",
                            value: formatValue(data.stats.filing_value, 2),
                            rawValue: data.stats.filing_value
                        });
                    }
                }
                else if (otherData.vt.toLowerCase() === "consensus") {
                    // show values without NA
                    data.stats.mean !== undefined && finalStats.details.push(this.createStatsDetails(data.stats.mean, "Mean", false));
                    data.stats.mn !== undefined && finalStats.details.push(this.createMinMaxDetails(data.stats.mn, "Min", false));
                    data.stats.mx !== undefined && finalStats.details.push(this.createMinMaxDetails(data.stats.mx, "Max", false));
                    data.stats.broker_count !== undefined && finalStats.details.push(this.createStatsDetails(data.stats.broker_count, "Broker Count", false));
                    data.stats.d !== undefined && finalStats.details.push(this.createStatsDetails(data.stats.d, "Standard Deviation", false));
                    data.stats.cv !== undefined && finalStats.details.push(this.createStatsDetails(data.stats.cv, "CV", false));
                    data.stats.median !== undefined && finalStats.details.push(this.createStatsDetails(data.stats.median, "Median", false));
                    data.stats.range !== undefined && finalStats.details.push(this.createStatsDetails(data.stats.range, "Range", false));
                    data.stats.consensus_ex_max !== undefined && finalStats.details.push(this.createStatsDetails(data.stats.consensus_ex_max, otherData.source.toLowerCase() === "consensus+" ? "Consensus+ExMax" : "ConsensusExMax", false));
                    data.stats.consensus_ex_min !== undefined && finalStats.details.push(this.createStatsDetails(data.stats.consensus_ex_min, otherData.source.toLowerCase() === "consensus+" ? "Consensus+ExMin" : "ConsensusExMin", false));
                    data.stats.consensus_ex_min_ex_max !== undefined && finalStats.details.push(this.createStatsDetails(data.stats.consensus_ex_min_ex_max, otherData.source.toLowerCase() === "consensus+" ? "Consensus+ExMinExMax" : "ConsensusExMinExMax", false));
                }
            }
            else if (data.stats && Object.keys(data.stats).length &&
                !data.show_brokers_only &&
                (otherData.period === 'LTM' ||
                    otherData.period === 'NTM' ||
                    otherData.period === 'STM' ||
                    (otherData.source &&
                        otherData.source.toLowerCase() !== 'va actuals'))) {
                finalStats.details.push(this.createStatsDetails(data.stats.mean, "Mean", true));
                finalStats.details.push(this.createMinMaxDetails(data.stats.mn, "Min", true));
                finalStats.details.push(this.createMinMaxDetails(data.stats.mx, "Max", true));
                finalStats.details.push(this.createStatsDetails(data.stats.broker_count, "Broker Count", true));
                finalStats.details.push(this.createStatsDetails(data.stats.d, "Standard Deviation", true));
                finalStats.details.push(this.createStatsDetails(data.stats.cv, "CV", true));
                finalStats.details.push(this.createStatsDetails(data.stats.median, "Median", true));
                finalStats.details.push(this.createStatsDetails(data.stats.range, "Range", true));
                finalStats.details.push(this.createStatsDetails(data.stats.consensus_ex_max, otherData.source.toLowerCase() === "consensus+" ? "Consensus+ExMax" : "ConsensusExMax", true));
                finalStats.details.push(this.createStatsDetails(data.stats.consensus_ex_min, otherData.source.toLowerCase() === "consensus+" ? "Consensus+ExMin" : "ConsensusExMin", true));
                finalStats.details.push(this.createStatsDetails(data.stats.consensus_ex_min_ex_max, otherData.source.toLowerCase() === "consensus+" ? "Consensus+ExMinExMax" : "ConsensusExMinExMax", true));
            }
            else if (data.stats && Object.keys(data.stats).length && data.show_brokers_only) {
                if (data.stats.broker_count !== undefined) {
                    finalStats.details.push(this.createStatsDetails(data.stats.broker_count, "Broker Count", false));
                }
            }
            return finalStats;
        }
    }
    createMinMaxDetails(obj, title, showNA) {
        if (obj && (obj.v || obj.v === 0)) {
            return {
                title: title,
                value: formatValue(obj.v, 2),
                rawValue: obj.v,
                sName: obj.sName
            };
        }
        else if (showNA) {
            return {
                title: title,
                value: "NA",
                rawValue: 0,
                sName: obj && obj.sName
            };
        }
        else {
            return {};
        }
    }
    createStatsDetails(value, title, showNA) {
        if (value !== undefined) {
            let precision = 2;
            if (title === "Broker Count" || title === "Number of brokers in mode") {
                precision = 0;
            }
            return {
                title: title,
                value: `${formatValue(value, precision)}${title === "CV" ? " %" : ""}`,
                rawValue: value
            };
        }
        else if (showNA) {
            return {
                title: title,
                value: "NA",
                rawValue: 0
            };
        }
        else {
            return {};
        }
    }
    // getStatsMinMaxText(element) {
    //   let value = "";
    //   if(element.v && element.sName) {
    //     value= `${formatValue(element.v, 2)}[${element.sName}]`;
    //   } else if(element.v) {
    //     value = formatValue(element.v, 2);
    //   } else {
    //     value = "NA";
    //   }
    //   return value;
    // }
    createStatsHeader(otherData, dpCallObj) {
        return {
            lineItemName: otherData.lineItemName,
            source: otherData.source,
            period: otherData.period,
            growthType: otherData.growthtype,
            historicalRevision: dpCallObj.historicalRevision,
            displayMagnitude: otherData.displayMagnitude,
            calculationMethod: otherData.calculation_method,
            fuzzyLineName: otherData.isFuzzy && otherData.fuzzyData
                ? otherData.fuzzyData.fuzzyLineName : "",
            details: []
        };
    }
    hideFBar() {
        this.showFormulaBar = false;
    }
    expandNode() {
        setTimeout(() => {
            const node = this.treeControl.dataNodes[0];
            this.treeControl.expand(node);
        }, 100);
    }
    collapseNode() {
        setTimeout(() => {
            const node = this.treeControl.dataNodes[0];
            this.treeControl.collapse(node);
        }, 100);
    }
    //On load, we need to scroll to the cell id, if specified in the model call
    onOpenFilingsDoc() {
        if (this.domIdToScroll !== "") {
            setTimeout(() => {
                const filingsDoc = document
                    .getElementById("filingsFrame")["contentWindow"].document.getElementById(this.domIdToScroll);
                filingsDoc.style.backgroundColor = "#FFE48D";
                filingsDoc.scrollIntoView();
            }, 1000);
        }
    }
    handleCancel() {
        this.isViewModalVisible = false;
    }
    downloadModel(node) {
        this.onDownloadModel.emit(node);
    }
    // downloadModel(node){
    //   const downloadType =
    //     node.item.source && node.item.source.toLowerCase() === "filings"
    //       ? "filings"
    //       : "model";
    //   if (node.item.modelData.file_type === "xlsx" && downloadType === "filings") {
    //     this.message.error(
    //       "Error: This filings document is in excel format and cannot be viewed",
    //       {
    //         nzDuration: 5000
    //       }
    //     );
    //   }
    //   const params ={
    //     documentId:node.item.modelData.documentId,
    //     ticker:node.item.baseInfo.dpCallObj.ticker,
    //     cut: node.item.cut,
    //     source: node.item.source,
    //     pg: node.item.baseInfo.dpCallObj.pg ? node.item.baseInfo.dpCallObj.pg : "",
    //     downloadType: downloadType,
    //     cellId: node.item.modelData.cellId,
    //   }
    //   if (downloadType === "filings") {
    //     //Filings documents are loaded in a popup
    //     let filingsParams = {};
    //     // if (this.openedForAddIn) {
    //     //   filingsParams = {
    //     //     //for filings we are passing the modeldetaildocumentID value to documnetId variable.
    //     //     documentId: node.modelDetailDocumentId,
    //     //     is_addin_call: true,
    //     //     ticker: this.routeSnapshot.queryParams.ticker,
    //     //     downloadType: downloadType,
    //     //     cut: this.routeSnapshot.queryParams.cut,
    //     //     pg: window.pg,
    //     //     cellId: node.cellRef
    //     //   };
    //     // } else {
    //     filingsParams = {
    //       //for filings we are passing the modeldetaildocumentID value to documnetId variable.
    //       documentId: node.item.modelData.documentId,
    //       // companyId: this.dpCallObj.companyId, // remove companyId and use ticker instead
    //       ticker: node.item.baseInfo.dpCallObj.ticker,
    //       downloadType: downloadType,
    //       cut: node.item.baseInfo.dpCallObj.cut,
    //       pg: node.item.baseInfo.pg ? node.item.baseInfo.pg : "",
    //       cellId: node.item.modelData.cellId
    //     };
    //     // }
    //     this.dataService.getViewModelSrc("", filingsParams).subscribe((msg) => {
    //       if (msg["fileType"] === "htm" || msg["fileType"] === "html") {
    //         this.domIdToScroll = msg.domId;
    //         this.isViewModalVisible = true;
    //         const options = {
    //           responseType: "text" as "text"
    //         };
    //         this.dataService.loadFilingsHTML(msg.url, options).subscribe(
    //           (htmlData) => {
    //             const doc = document.getElementById("filingsFrame")[
    //               "contentWindow"
    //             ].document;
    //             doc.open();
    //             doc.write(htmlData);
    //             doc.close();
    //             this.onOpenFilingsDoc();
    //           },
    //           (error) => {
    //             console.error(error);
    //           }
    //         );
    //       }
    //       if (msg["fileType"] === "pdf") {
    //         this.isViewModalVisible = true;
    //         this.filingsError = false;
    //         const options = {
    //           responseType: "arraybuffer"
    //         };
    //         filingsParams = {
    //           documentId: node.item.modelData.documentId,
    //           cellId: node.item.modelData.cellId
    //         };
    //         this.dataService.getPDFFilings("", filingsParams, options).subscribe(
    //           (pdfData) => {
    //             if (pdfData["status"] === "error") {
    //               console.error(pdfData["message"]);
    //             } else {
    //               const file = new Blob([pdfData], { type: "application/pdf" });
    //               const fileURL = URL.createObjectURL(file);
    //               document
    //                 .getElementById("filingsFrame")
    //                 .setAttribute("src", fileURL);
    //             }
    //           },
    //           (error) => {
    //             console.error(error);
    //           }
    //         );
    //       }
    //       if (msg.status === "error") {
    //         this.filingsError = true;
    //         this.isViewModalVisible = true;
    //       } else {
    //         this.filingsError = false;
    //       }
    //       if (msg.force_logout) {
    //         window.location.href = `/homepage/?force_logout=true`; //${this.legacyUrl}
    //       }
    //     });
    //   } else {
    //     this.excelDownload(this.apiEP, params)
    //   }
    // }
    // excelDownload(event: any, excelTrackerId, tickerName, exportType?: string, actionSource?: string, extras?: any) {
    excelDownload(apiEP, extraParams) {
        const exportType = 'model_download';
        let uniqueId = "";
        uniqueId = extraParams.excelTrackerId;
        let url = `${apiEP}/api/model?documentid=${extraParams.documentId}&source=${extraParams.source}&pg=${extraParams.pg}&downloadType=${extraParams.downloadType}&cellId=${extraParams.cellId}&ticker=${extraParams.ticker}&cut=${extraParams.cut}`;
        //let url = "https://webapp-uat-insights.visiblealpha.com/api/model?documentid=3553315&source=Seaport&pg=&downloadType=model&cellId=AL78&ticker=AAL&cut=SAR"     
        uniqueId = extraParams.documentId;
        const iFrameToLoad = this._document.createElement("iframe");
        const body = this._document.getElementsByTagName("body")[0];
        iFrameToLoad.setAttribute("id", `${exportType}_${uniqueId}`);
        iFrameToLoad.setAttribute("name", `${exportType}_${uniqueId}`);
        iFrameToLoad.setAttribute("src", url);
        iFrameToLoad.setAttribute("style", "visibility:hidden; display:none");
        body.appendChild(iFrameToLoad);
        iFrameToLoad.onload = () => {
            let res = frames[`${exportType}_${uniqueId}`].document.getElementsByTagName("body")[0].innerHTML;
            if (res) {
                try {
                    res = JSON.parse(res);
                    if (res.status === "error") {
                        if (exportType === "model_download") {
                            console.error(`Error: `);
                            this.message.error(`Error: ${res.message}`, {
                                nzDuration: 5000
                            });
                        }
                        console.error(`Failed to download file, ${res["filename"]} for source  .`);
                    }
                    if (res.force_logout) {
                        if (exportType === "model_download") {
                            window.location.href = `${apiEP}/homepage/?force_logout=true`;
                        }
                    }
                }
                catch (err) {
                    if (exportType === "model_download") {
                        if (res.indexOf("VAHOMEPAGE") > -1 ||
                            res.indexOf("Forgot Password") > -1) {
                            window.location.href = `${apiEP}/homepage/?force_logout=true`;
                        }
                    }
                    console.error(err);
                }
            }
        };
        if (extraParams.iFrameDestructCb) {
            const startIFrameTime = new Date().getTime();
            const checkInterval = setInterval(() => {
                const iFrameToGet = this._document.getElementById(`${exportType}_${uniqueId}`);
                const iFrame = iFrameToGet.contentDocument || iFrameToGet.contentWindow.document;
                /*
                This check will run till the iFrame either doesn't load or for a max of 30secs
                Or till the ready state of the iFrame doesn't evaluate
              */
                if (iFrame.readyState === "complete" ||
                    iFrame.readyState === "interactive" ||
                    new Date().getTime() - startIFrameTime > 30000) {
                    clearInterval(checkInterval);
                    extraParams.iFrameDestructCb();
                    return;
                }
            }, 2000);
        }
    }
    onToggleTreeNode(node, isExpanded) {
        this.onNodeToggle.emit({ node, isExpanded });
    }
    // close fbar if exc key is pressed -- not working 
    isEscKeyPressed(event) {
        let isEscape = false;
        isEscape = "key" in event ? event.key === "Escape" || event.key === "Esc" : isEscape;
        if (isEscape) {
            this.collapseNode();
        }
        // this.dataSource.toggleNode(this.treeControl.dataNodes[0], false);
        // this.treeControl.expansionModel.changed.next({
        //   source: {} as any,
        //   added: [],
        //   removed: [{
        //     ...this.treeControl.dataNodes[0]
        //   }]
        // })
        // let isEscape = false;
        // isEscape =
        //   "key" in event ? event.key === "Escape" || event.key === "Esc" : isEscape;
        // isEscape = (event.which == 27);
        // if (isEscape && this.fbarExpanded) {
        //   const node: NzTreeNode = this.nzTreeComponent.getTreeNodeByKey(
        //     "expandFbar"
        //   );
        //   node.isExpanded = false;
        //   this.fbarExpanded = false;
        // }
    }
    loadViewinNewTab(event, node) {
        //Adding this for a bug which collapses the row after redirect
        event.stopPropagation();
        if (this.disableLinks) {
            return;
        }
        let dpId = node.item.id;
        if (node.item.id) {
            // remove #<number> appended to dp id to make it unique -- # was added by FE
            // then remove SAR_ prefix from the dp id -- This is what is received from BE, but mex grid has dp id
            // without SAR_ or NMV_ etc prefix
            dpId = node.item.id.split("#")[0];
            if (dpId.indexOf("_") !== -1) {
                dpId = dpId.split("_")[1];
            }
        }
        const dp = encodeURIComponent(`${dpId}|${node.item.revision_date}`);
        // const dp = encodeURIComponent(`${this.dpCallObj.dp}`);
        const url = `/mex/${this.dpCallObj.ticker}/${node.item.prefix}/${fixedEncodeURIComponent(node.item.parameter_group_info)}/${node.item.source}?expand_consensus=true&dpid=${dp}&period=${node.item.fiscalPeriod}`;
        // const url = `/mex/${
        //   this.dpCallObj.ticker
        // }/${node.item.prefix}/${node.item.parameter_group_info}/${node.item.source}?expand_consensus=true&dpid=${dp}`;
        window.open(url, "_blank");
    }
}
FormulaBarComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: FormulaBarComponent, deps: [{ token: i1$2.NzMessageService }, { token: FormulaBarDataService }, { token: FormulaBarUtilsService }, { token: DOCUMENT }, { token: i4$1.VAIconRegistryService }], target: i0.ɵɵFactoryTarget.Component });
FormulaBarComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: FormulaBarComponent, selector: "va-formula-bar", inputs: { apiEP: "apiEP", apiUrl: "apiUrl", disableLinks: "disableLinks", dpCallObj: "dpCallObj", expandOnInit: "expandOnInit" }, outputs: { onNodeToggle: "onNodeToggle", onDownloadModel: "onDownloadModel" }, host: { listeners: { "document:keydown": "isEscKeyPressed($event)" }, classAttribute: "formulabar-component" }, usesOnChanges: true, ngImport: i0, template: "<div class=\"formula-bar\" *ngIf=\"showFormulaBar\">\n  <mat-progress-bar *ngIf=\"isFbLoading && !isError\" mode=\"indeterminate\" class=\"tree-progress-bar\"></mat-progress-bar>\n  <div *ngIf=\"isError && !isFbLoading\"> {{errorMessage}}</div>\n  <mat-tree *ngIf=\"!isFbLoading && !isError\" [dataSource]=\"dataSource\" [treeControl]=\"treeControl\" class=\"formula-bar-tree\">\n    <!-- This is the tree node template for leaf nodes -->\n    <mat-tree-node *matTreeNodeDef=\"let node\" [ngClass]= \"{ 'root-node-expanded' : node.level === 0 && treeControl.isExpanded(node),'root-node' : node.level === 0}\">\n      <!-- use a dummy button to provide padding for tree leaf -->\n        <span class=\"toggle-btn-dummy\"></span>\n        <div class=\"leaf-node tree-node-content\">\n          <span\n            class=\"display-expr-leaf\"\n            [innerHtml]=\"node.item.displayVal\"\n          ></span>\n          <div *ngIf=\"node.item.isModelLine\">\n            <span\n              (click)=\"downloadModel(node)\"\n              class=\"info-icon\"\n              nz-tooltip\n              [nzTooltipTitle]=\"node.item.source.toLowerCase() === 'filings' ? 'Show filings' : 'Download model'\"\n              nzTooltipPlacement=\"top\"\n              >\n              &nbsp;\n              <va-icon\n                size=\"small\"\n                name=\"file-excel\"\n              ></va-icon>\n              &nbsp;]\n            </span>\n          </div>\n          <div class=\"info-container\" *ngIf=\"!node.item.isModelLine\">\n            <div\n              class=\"fb-info\"\n              nz-tooltip\n              [nzTooltipTitle]=\"node.item.infoText\"\n              nzTooltipPlacement=\"top\"\n            >\n              {{node.item.infoText}}\n            </div>\n          </div>\n        </div>\n    </mat-tree-node>\n    <!-- This is the tree node template for expandable nodes -->\n    <mat-nested-tree-node *matTreeNodeDef=\"let node;when: hasChildTT\" \n      [ngClass]= \"{ \n        'root-node-expanded' : node.level === 0 && treeControl.isExpanded(node),\n        'first-node': node.level === 0\n      }\">\n      <div matTreeNodeToggle (click)=\"onToggleTreeNode(node, treeControl.isExpanded(node))\" class=\"mat-tree-node\"  [ngClass]=\"{ 'root-node': node.level === 0 }\">\n        <span>\n          <va-icon size=\"small\" [name]=\"treeControl.isExpanded(node) ? 'caret-down' : 'caret-right'\"></va-icon>\n        </span>\n        <div class=\"tree-node-content\">\n          <span class=\"display-expr\"\n            [ngClass]=\"{\n              'fuzzy-info': node.isFuzzy\n            }\"\n            [innerHtml]=\"node.item.displayVal\"\n          ></span>\n          <span *ngIf=\"node.isFuzzy && node.level === 0 && treeControl.isExpanded(node)\">\n            <span [innerHtml]=\"node.item.displayValFuzzy\"></span>\n          </span>\n          <div class=\"info-container\" *ngIf=\"!node.item.showLink\">\n            <div\n              class=\"fb-info\"\n              nz-tooltip\n              nzTooltipPlacement=\"bottom\"\n              [nzTooltipTitle]=\"\n                node.item.infoText\n              \"\n            >\n              {{node.item.infoText}}\n            </div>\n          </div>\n          <div class=\"info-container\" *ngIf=\"node.item.showLink \">\n            <a\n              class=\"fb-info\"\n              [ngClass]=\"[disableLinks ? 'dumb-anchor-tag' : '']\"\n              nz-tooltip\n              nzTooltipPlacement=\"bottom\"\n              [nzTooltipTitle]=\"\n                disableLinks ? null : childExpressionLinkTooltip\n              \"\n              (click)=\"loadViewinNewTab($event, node)\"\n            >\n              {{node.item.infoText}}\n            </a>\n            <ng-template #childExpressionLinkTooltip>\n              <!-- <span\n                *ngIf=\"\n                  node.origin.popOverText && node.origin.popOverText.length > 70\n                \"\n                >{{ node.origin.popOverText }},\n              </span> -->\n              <span\n                >{{node.item.infoTooltip}}</span\n              >\n            </ng-template>\n          </div>\n          <mat-progress-bar *ngIf=\"node.isLoading\" mode=\"indeterminate\" class=\"tree-progress-bar\"></mat-progress-bar>\n        </div>\n      </div>\n      <div class=\"nested-row\" \n        [ngClass]=\"{\n          'example-tree-invisible': !treeControl.isExpanded(node),\n          'first-expanded-node': node.level === 0\n        }\"  \n      >\n        <ng-container matTreeNodeOutlet></ng-container>\n      </div>\n      <mat-tree-node *ngIf=\"treeControl.isExpanded(node) && node.level === 0\" class=\"stats-node\">\n        <va-formula-bar-stats\n          *ngIf=\"!directMappings\"\n          [dpCallObj]=\"dpCallObj\"\n          [statsData]=\"statsT\"\n        ></va-formula-bar-stats>\n        <va-direct-mappings\n          *ngIf=\"dpCallObj.cut === 'SAR' && directMappings\"\n          class=\"direct-mappings-section\"\n          [dpCallObj]=\"dpCallObj\"\n          [directMappings]=\"directMappings\"\n          [disableLinks]=\"disableLinks\"\n        ></va-direct-mappings>\n      </mat-tree-node>\n    </mat-nested-tree-node>\n  </mat-tree>\n</div>\n\n<nz-modal\n  [(nzVisible)]=\"isViewModalVisible\"\n  [nzFooter]=\"null\"\n  nzWidth=\"800px\"\n  (nzOnCancel)=\"handleCancel()\"\n  nzTitle=\"&nbsp;\"\n  nzClassName=\"custom-consensus-popup-container formulabar-filings-modal\"\n>\n  <ng-container *nzModalContent>\n    <iframe\n      id=\"filingsFrame\"\n      frameborder=\"0\"\n      allowfullscreen\n      width=\"100%\"\n      height=\"500px\"\n      *ngIf=\"!filingsError\"\n    ></iframe>\n    <div id=\"filings-error\" class=\"error-container\" *ngIf=\"filingsError\">\n      <div class=\"error-msg\">\n        <va-icon name=\"info-circle\" class=\"info-icon\"></va-icon>\n        <span class=\"error-text\">Fillings not found</span>\n      </div>\n    </div>\n  </ng-container>\n</nz-modal>", styles: [".formulabar-component:host{margin:0;padding:0;position:relative}.formula-bar{width:100%;max-width:1200px;border-radius:2px;z-index:9;height:100%;color:#000;position:relative}.formula-bar .root-node{width:100%;position:relative}.formula-bar .root-node-expanded{width:100%}.formula-bar .tree-progress-bar.mat-mdc-progress-bar{width:80%;margin-left:16px;margin-top:4px;float:left}.formula-bar .tree-progress-bar.mat-mdc-progress-bar .mdc-linear-progress__bar-inner{border-color:#2c8d7d}.formula-bar .tree-progress-bar.mat-mdc-progress-bar .mdc-linear-progress__buffer-bar{background-color:#36abad}.formula-bar .tree-progress-bar.mat-mdc-progress-bar .mat-mdc-progress-bar-background{animation:none;background-color:#eceff1;fill:#eceff1}.formula-bar .formula-bar-tree li{list-style:none}.formula-bar .formula-bar-tree .mat-nested-tree-node,.formula-bar .formula-bar-tree .mat-tree-node{color:#000;line-height:14px;min-height:20px}.formula-bar .formula-bar-tree .mat-nested-tree-node.root-node,.formula-bar .formula-bar-tree .mat-tree-node.root-node{height:100%;position:sticky;background:#fff}.formula-bar .formula-bar-tree .mat-nested-tree-node:not(.root-node-expanded) .root-node .tree-node-content,.formula-bar .formula-bar-tree .mat-tree-node:not(.root-node-expanded) .root-node .tree-node-content{max-height:20px;overflow:hidden}.formula-bar .formula-bar-tree .mat-nested-tree-node .nested-row.first-expanded-node,.formula-bar .formula-bar-tree .mat-tree-node .nested-row.first-expanded-node{max-height:170px;position:relative}.formula-bar .formula-bar-tree .mat-nested-tree-node .nested-row,.formula-bar .formula-bar-tree .mat-tree-node .nested-row{padding-left:15px;width:100%;overflow-y:auto}.formula-bar .formula-bar-tree .mat-nested-tree-node>.nested-row>.mat-nested-tree-node,.formula-bar .formula-bar-tree .mat-tree-node>.nested-row>.mat-nested-tree-node{display:block;margin-bottom:2px;background-color:#f2f2f2}.formula-bar .formula-bar-tree .mat-nested-tree-node>.nested-row>.mat-tree-node,.formula-bar .formula-bar-tree .mat-tree-node>.nested-row>.mat-tree-node{background-color:#f2f2f2}.formula-bar .formula-bar-tree .mat-nested-tree-node .toggle-btn,.formula-bar .formula-bar-tree .mat-tree-node .toggle-btn{cursor:pointer;height:20px;width:20px;line-height:18px;font-size:14px;padding:2px;border-radius:16px;color:#667284}.formula-bar .formula-bar-tree .mat-nested-tree-node .toggle-btn svg,.formula-bar .formula-bar-tree .mat-tree-node .toggle-btn svg{vertical-align:baseline}.formula-bar .formula-bar-tree .mat-nested-tree-node .toggle-btn:hover,.formula-bar .formula-bar-tree .mat-tree-node .toggle-btn:hover{background-color:#e0e1e1}.formula-bar .formula-bar-tree .mat-nested-tree-node .toggle-btn-dummy,.formula-bar .formula-bar-tree .mat-tree-node .toggle-btn-dummy{width:20px;cursor:none;background-color:unset}.formula-bar .formula-bar-tree .tree-node-content{display:inline-block;width:100%;font-size:11px;font-family:Open Sans,sans-serif!important;padding:4px}.formula-bar .formula-bar-tree .tree-node-content .display-expr-leaf{float:left;text-overflow:ellipsis;overflow:hidden;white-space:nowrap;max-width:90%}.formula-bar .formula-bar-tree .tree-node-content .display-expr-leaf .negative-number{color:#e61f00}.formula-bar .formula-bar-tree .tree-node-content .display-expr{float:left;width:44%}.formula-bar .formula-bar-tree .tree-node-content .display-expr .negative-number{color:#e61f00}.formula-bar .formula-bar-tree .tree-node-content .info-icon{cursor:pointer}.formula-bar .formula-bar-tree .tree-node-content .fuzzy-info{color:#e6a935}.formula-bar .formula-bar-tree .tree-node-content .info-container{float:right;width:50%}.formula-bar .formula-bar-tree .tree-node-content .info-container .fb-info{text-overflow:ellipsis;overflow:hidden;white-space:nowrap}.formula-bar .formula-bar-tree .tree-node-content .info-container a.fb-info{display:block}.formula-bar .formula-bar-tree .root-node .display-expr{width:100%}.formula-bar .direct-mappings-section{width:100%;background-color:#fff}.error-container{display:flex;justify-content:space-around}.error-container .info-icon{color:#36abad}.error-container .info-icon svg{vertical-align:middle}\n"], dependencies: [{ kind: "directive", type: i1$1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i6.MatNestedTreeNode, selector: "mat-nested-tree-node", inputs: ["role", "disabled", "tabIndex", "matNestedTreeNode"], exportAs: ["matNestedTreeNode"] }, { kind: "directive", type: i6.MatTreeNodeDef, selector: "[matTreeNodeDef]", inputs: ["matTreeNodeDefWhen", "matTreeNode"] }, { kind: "directive", type: i6.MatTreeNodeToggle, selector: "[matTreeNodeToggle]", inputs: ["matTreeNodeToggleRecursive"] }, { kind: "component", type: i6.MatTree, selector: "mat-tree", exportAs: ["matTree"] }, { kind: "directive", type: i6.MatTreeNode, selector: "mat-tree-node", inputs: ["role", "disabled", "tabIndex"], exportAs: ["matTreeNode"] }, { kind: "directive", type: i6.MatTreeNodeOutlet, selector: "[matTreeNodeOutlet]" }, { kind: "component", type: i7.MatProgressBar, selector: "mat-progress-bar", inputs: ["color", "value", "bufferValue", "mode"], outputs: ["animationEnd"], exportAs: ["matProgressBar"] }, { kind: "directive", type: i3.NzTooltipDirective, selector: "[nz-tooltip]", inputs: ["nzTooltipTitle", "nzTooltipTitleContext", "nz-tooltip", "nzTooltipTrigger", "nzTooltipPlacement", "nzTooltipOrigin", "nzTooltipVisible", "nzTooltipMouseEnterDelay", "nzTooltipMouseLeaveDelay", "nzTooltipOverlayClassName", "nzTooltipOverlayStyle", "nzTooltipArrowPointAtCenter", "nzTooltipColor"], outputs: ["nzTooltipVisibleChange"], exportAs: ["nzTooltip"] }, { kind: "component", type: i9.NzModalComponent, selector: "nz-modal", inputs: ["nzMask", "nzMaskClosable", "nzCloseOnNavigation", "nzVisible", "nzClosable", "nzOkLoading", "nzOkDisabled", "nzCancelDisabled", "nzCancelLoading", "nzKeyboard", "nzNoAnimation", "nzCentered", "nzContent", "nzComponentParams", "nzFooter", "nzZIndex", "nzWidth", "nzWrapClassName", "nzClassName", "nzStyle", "nzTitle", "nzCloseIcon", "nzMaskStyle", "nzBodyStyle", "nzOkText", "nzCancelText", "nzOkType", "nzOkDanger", "nzIconType", "nzModalType", "nzAutofocus", "nzOnOk", "nzOnCancel"], outputs: ["nzOnOk", "nzOnCancel", "nzAfterOpen", "nzAfterClose", "nzVisibleChange"], exportAs: ["nzModal"] }, { kind: "directive", type: i9.NzModalContentDirective, selector: "[nzModalContent]", exportAs: ["nzModalContent"] }, { kind: "component", type: i4$1.IconComponent, selector: "va-icon", inputs: ["spin", "isFontAwesome", "styles", "size", "name"] }, { kind: "component", type: FormulaBarStatsComponent, selector: "va-formula-bar-stats", inputs: ["apiEP", "dpCallObj", "statsData"] }, { kind: "component", type: DirectMappingsComponent, selector: "va-direct-mappings", inputs: ["dpCallObj", "disableLinks", "directMappings"] }], encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: FormulaBarComponent, decorators: [{
            type: Component,
            args: [{ selector: 'va-formula-bar', host: {
                        class: "formulabar-component",
                        "(document:keydown)": "isEscKeyPressed($event)"
                    }, encapsulation: ViewEncapsulation.None, template: "<div class=\"formula-bar\" *ngIf=\"showFormulaBar\">\n  <mat-progress-bar *ngIf=\"isFbLoading && !isError\" mode=\"indeterminate\" class=\"tree-progress-bar\"></mat-progress-bar>\n  <div *ngIf=\"isError && !isFbLoading\"> {{errorMessage}}</div>\n  <mat-tree *ngIf=\"!isFbLoading && !isError\" [dataSource]=\"dataSource\" [treeControl]=\"treeControl\" class=\"formula-bar-tree\">\n    <!-- This is the tree node template for leaf nodes -->\n    <mat-tree-node *matTreeNodeDef=\"let node\" [ngClass]= \"{ 'root-node-expanded' : node.level === 0 && treeControl.isExpanded(node),'root-node' : node.level === 0}\">\n      <!-- use a dummy button to provide padding for tree leaf -->\n        <span class=\"toggle-btn-dummy\"></span>\n        <div class=\"leaf-node tree-node-content\">\n          <span\n            class=\"display-expr-leaf\"\n            [innerHtml]=\"node.item.displayVal\"\n          ></span>\n          <div *ngIf=\"node.item.isModelLine\">\n            <span\n              (click)=\"downloadModel(node)\"\n              class=\"info-icon\"\n              nz-tooltip\n              [nzTooltipTitle]=\"node.item.source.toLowerCase() === 'filings' ? 'Show filings' : 'Download model'\"\n              nzTooltipPlacement=\"top\"\n              >\n              &nbsp;\n              <va-icon\n                size=\"small\"\n                name=\"file-excel\"\n              ></va-icon>\n              &nbsp;]\n            </span>\n          </div>\n          <div class=\"info-container\" *ngIf=\"!node.item.isModelLine\">\n            <div\n              class=\"fb-info\"\n              nz-tooltip\n              [nzTooltipTitle]=\"node.item.infoText\"\n              nzTooltipPlacement=\"top\"\n            >\n              {{node.item.infoText}}\n            </div>\n          </div>\n        </div>\n    </mat-tree-node>\n    <!-- This is the tree node template for expandable nodes -->\n    <mat-nested-tree-node *matTreeNodeDef=\"let node;when: hasChildTT\" \n      [ngClass]= \"{ \n        'root-node-expanded' : node.level === 0 && treeControl.isExpanded(node),\n        'first-node': node.level === 0\n      }\">\n      <div matTreeNodeToggle (click)=\"onToggleTreeNode(node, treeControl.isExpanded(node))\" class=\"mat-tree-node\"  [ngClass]=\"{ 'root-node': node.level === 0 }\">\n        <span>\n          <va-icon size=\"small\" [name]=\"treeControl.isExpanded(node) ? 'caret-down' : 'caret-right'\"></va-icon>\n        </span>\n        <div class=\"tree-node-content\">\n          <span class=\"display-expr\"\n            [ngClass]=\"{\n              'fuzzy-info': node.isFuzzy\n            }\"\n            [innerHtml]=\"node.item.displayVal\"\n          ></span>\n          <span *ngIf=\"node.isFuzzy && node.level === 0 && treeControl.isExpanded(node)\">\n            <span [innerHtml]=\"node.item.displayValFuzzy\"></span>\n          </span>\n          <div class=\"info-container\" *ngIf=\"!node.item.showLink\">\n            <div\n              class=\"fb-info\"\n              nz-tooltip\n              nzTooltipPlacement=\"bottom\"\n              [nzTooltipTitle]=\"\n                node.item.infoText\n              \"\n            >\n              {{node.item.infoText}}\n            </div>\n          </div>\n          <div class=\"info-container\" *ngIf=\"node.item.showLink \">\n            <a\n              class=\"fb-info\"\n              [ngClass]=\"[disableLinks ? 'dumb-anchor-tag' : '']\"\n              nz-tooltip\n              nzTooltipPlacement=\"bottom\"\n              [nzTooltipTitle]=\"\n                disableLinks ? null : childExpressionLinkTooltip\n              \"\n              (click)=\"loadViewinNewTab($event, node)\"\n            >\n              {{node.item.infoText}}\n            </a>\n            <ng-template #childExpressionLinkTooltip>\n              <!-- <span\n                *ngIf=\"\n                  node.origin.popOverText && node.origin.popOverText.length > 70\n                \"\n                >{{ node.origin.popOverText }},\n              </span> -->\n              <span\n                >{{node.item.infoTooltip}}</span\n              >\n            </ng-template>\n          </div>\n          <mat-progress-bar *ngIf=\"node.isLoading\" mode=\"indeterminate\" class=\"tree-progress-bar\"></mat-progress-bar>\n        </div>\n      </div>\n      <div class=\"nested-row\" \n        [ngClass]=\"{\n          'example-tree-invisible': !treeControl.isExpanded(node),\n          'first-expanded-node': node.level === 0\n        }\"  \n      >\n        <ng-container matTreeNodeOutlet></ng-container>\n      </div>\n      <mat-tree-node *ngIf=\"treeControl.isExpanded(node) && node.level === 0\" class=\"stats-node\">\n        <va-formula-bar-stats\n          *ngIf=\"!directMappings\"\n          [dpCallObj]=\"dpCallObj\"\n          [statsData]=\"statsT\"\n        ></va-formula-bar-stats>\n        <va-direct-mappings\n          *ngIf=\"dpCallObj.cut === 'SAR' && directMappings\"\n          class=\"direct-mappings-section\"\n          [dpCallObj]=\"dpCallObj\"\n          [directMappings]=\"directMappings\"\n          [disableLinks]=\"disableLinks\"\n        ></va-direct-mappings>\n      </mat-tree-node>\n    </mat-nested-tree-node>\n  </mat-tree>\n</div>\n\n<nz-modal\n  [(nzVisible)]=\"isViewModalVisible\"\n  [nzFooter]=\"null\"\n  nzWidth=\"800px\"\n  (nzOnCancel)=\"handleCancel()\"\n  nzTitle=\"&nbsp;\"\n  nzClassName=\"custom-consensus-popup-container formulabar-filings-modal\"\n>\n  <ng-container *nzModalContent>\n    <iframe\n      id=\"filingsFrame\"\n      frameborder=\"0\"\n      allowfullscreen\n      width=\"100%\"\n      height=\"500px\"\n      *ngIf=\"!filingsError\"\n    ></iframe>\n    <div id=\"filings-error\" class=\"error-container\" *ngIf=\"filingsError\">\n      <div class=\"error-msg\">\n        <va-icon name=\"info-circle\" class=\"info-icon\"></va-icon>\n        <span class=\"error-text\">Fillings not found</span>\n      </div>\n    </div>\n  </ng-container>\n</nz-modal>", styles: [".formulabar-component:host{margin:0;padding:0;position:relative}.formula-bar{width:100%;max-width:1200px;border-radius:2px;z-index:9;height:100%;color:#000;position:relative}.formula-bar .root-node{width:100%;position:relative}.formula-bar .root-node-expanded{width:100%}.formula-bar .tree-progress-bar.mat-mdc-progress-bar{width:80%;margin-left:16px;margin-top:4px;float:left}.formula-bar .tree-progress-bar.mat-mdc-progress-bar .mdc-linear-progress__bar-inner{border-color:#2c8d7d}.formula-bar .tree-progress-bar.mat-mdc-progress-bar .mdc-linear-progress__buffer-bar{background-color:#36abad}.formula-bar .tree-progress-bar.mat-mdc-progress-bar .mat-mdc-progress-bar-background{animation:none;background-color:#eceff1;fill:#eceff1}.formula-bar .formula-bar-tree li{list-style:none}.formula-bar .formula-bar-tree .mat-nested-tree-node,.formula-bar .formula-bar-tree .mat-tree-node{color:#000;line-height:14px;min-height:20px}.formula-bar .formula-bar-tree .mat-nested-tree-node.root-node,.formula-bar .formula-bar-tree .mat-tree-node.root-node{height:100%;position:sticky;background:#fff}.formula-bar .formula-bar-tree .mat-nested-tree-node:not(.root-node-expanded) .root-node .tree-node-content,.formula-bar .formula-bar-tree .mat-tree-node:not(.root-node-expanded) .root-node .tree-node-content{max-height:20px;overflow:hidden}.formula-bar .formula-bar-tree .mat-nested-tree-node .nested-row.first-expanded-node,.formula-bar .formula-bar-tree .mat-tree-node .nested-row.first-expanded-node{max-height:170px;position:relative}.formula-bar .formula-bar-tree .mat-nested-tree-node .nested-row,.formula-bar .formula-bar-tree .mat-tree-node .nested-row{padding-left:15px;width:100%;overflow-y:auto}.formula-bar .formula-bar-tree .mat-nested-tree-node>.nested-row>.mat-nested-tree-node,.formula-bar .formula-bar-tree .mat-tree-node>.nested-row>.mat-nested-tree-node{display:block;margin-bottom:2px;background-color:#f2f2f2}.formula-bar .formula-bar-tree .mat-nested-tree-node>.nested-row>.mat-tree-node,.formula-bar .formula-bar-tree .mat-tree-node>.nested-row>.mat-tree-node{background-color:#f2f2f2}.formula-bar .formula-bar-tree .mat-nested-tree-node .toggle-btn,.formula-bar .formula-bar-tree .mat-tree-node .toggle-btn{cursor:pointer;height:20px;width:20px;line-height:18px;font-size:14px;padding:2px;border-radius:16px;color:#667284}.formula-bar .formula-bar-tree .mat-nested-tree-node .toggle-btn svg,.formula-bar .formula-bar-tree .mat-tree-node .toggle-btn svg{vertical-align:baseline}.formula-bar .formula-bar-tree .mat-nested-tree-node .toggle-btn:hover,.formula-bar .formula-bar-tree .mat-tree-node .toggle-btn:hover{background-color:#e0e1e1}.formula-bar .formula-bar-tree .mat-nested-tree-node .toggle-btn-dummy,.formula-bar .formula-bar-tree .mat-tree-node .toggle-btn-dummy{width:20px;cursor:none;background-color:unset}.formula-bar .formula-bar-tree .tree-node-content{display:inline-block;width:100%;font-size:11px;font-family:Open Sans,sans-serif!important;padding:4px}.formula-bar .formula-bar-tree .tree-node-content .display-expr-leaf{float:left;text-overflow:ellipsis;overflow:hidden;white-space:nowrap;max-width:90%}.formula-bar .formula-bar-tree .tree-node-content .display-expr-leaf .negative-number{color:#e61f00}.formula-bar .formula-bar-tree .tree-node-content .display-expr{float:left;width:44%}.formula-bar .formula-bar-tree .tree-node-content .display-expr .negative-number{color:#e61f00}.formula-bar .formula-bar-tree .tree-node-content .info-icon{cursor:pointer}.formula-bar .formula-bar-tree .tree-node-content .fuzzy-info{color:#e6a935}.formula-bar .formula-bar-tree .tree-node-content .info-container{float:right;width:50%}.formula-bar .formula-bar-tree .tree-node-content .info-container .fb-info{text-overflow:ellipsis;overflow:hidden;white-space:nowrap}.formula-bar .formula-bar-tree .tree-node-content .info-container a.fb-info{display:block}.formula-bar .formula-bar-tree .root-node .display-expr{width:100%}.formula-bar .direct-mappings-section{width:100%;background-color:#fff}.error-container{display:flex;justify-content:space-around}.error-container .info-icon{color:#36abad}.error-container .info-icon svg{vertical-align:middle}\n"] }]
        }], ctorParameters: function () { return [{ type: i1$2.NzMessageService }, { type: FormulaBarDataService }, { type: FormulaBarUtilsService }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [DOCUMENT]
                }] }, { type: i4$1.VAIconRegistryService }]; }, propDecorators: { apiEP: [{
                type: Input
            }], apiUrl: [{
                type: Input
            }], disableLinks: [{
                type: Input
            }], dpCallObj: [{
                type: Input
            }], expandOnInit: [{
                type: Input
            }], onNodeToggle: [{
                type: Output
            }], onDownloadModel: [{
                type: Output
            }] } });

class FormulaBarModule {
}
FormulaBarModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: FormulaBarModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
FormulaBarModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "15.2.10", ngImport: i0, type: FormulaBarModule, declarations: [FormulaBarStatsComponent, FormulaBarComponent, DirectMappingsComponent], imports: [CommonModule,
        RouterModule,
        MatTreeModule,
        MatInputModule,
        MatIconModule,
        MatTableModule,
        MatButtonModule,
        MatProgressBarModule,
        NzToolTipModule,
        NzGridModule,
        // MatSnackBarModule,
        NzModalModule,
        NzMessageModule,
        NzMessageServiceModule,
        CustomSkeletonModule,
        IconsModule,
        ButtonModule,
        FontAwesomeModule], exports: [FormulaBarComponent, FormulaBarStatsComponent] });
FormulaBarModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: FormulaBarModule, imports: [CommonModule,
        RouterModule,
        MatTreeModule,
        MatInputModule,
        MatIconModule,
        MatTableModule,
        MatButtonModule,
        MatProgressBarModule,
        NzToolTipModule,
        NzGridModule,
        // MatSnackBarModule,
        NzModalModule,
        NzMessageModule,
        NzMessageServiceModule,
        CustomSkeletonModule,
        IconsModule,
        ButtonModule,
        FontAwesomeModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: FormulaBarModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [FormulaBarStatsComponent, FormulaBarComponent, DirectMappingsComponent],
                    imports: [
                        CommonModule,
                        RouterModule,
                        MatTreeModule,
                        MatInputModule,
                        MatIconModule,
                        MatTableModule,
                        MatButtonModule,
                        MatProgressBarModule,
                        NzToolTipModule,
                        NzGridModule,
                        // MatSnackBarModule,
                        NzModalModule,
                        NzMessageModule,
                        NzMessageServiceModule,
                        CustomSkeletonModule,
                        IconsModule,
                        ButtonModule,
                        FontAwesomeModule
                    ],
                    exports: [FormulaBarComponent, FormulaBarStatsComponent]
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { CONSTANTS, DirectMappingsComponent, FormulaBarComponent, FormulaBarModule, FormulaBarStatsComponent };
